const getHandledValue = num => {
  return num < 10 ? '0' + num : num
}

/**
 * @param {Number} timeStamp 传入的时间戳
 * @param {Number} startType 要返回的时间字符串的格式类型，传入'year'则返回年开头的完整时间
 */
export const getDate = (timeStamp, startType) => {
  // if(timeStamp !== undefined && !isNaN(timeStamp)){
  if (timeStamp !== undefined) {
    return getDateStr(new Date(timeStamp), startType)
  } else {
    return ''
  }
}
export const getDateStr = (d, startType) => {
  if (d instanceof Date) {
    const year = d.getFullYear()
    const month = getHandledValue(d.getMonth() + 1)
    const date = getHandledValue(d.getDate())
    const hours = getHandledValue(d.getHours())
    const minutes = getHandledValue(d.getMinutes())
    const second = getHandledValue(d.getSeconds())
    let resStr = ''
    if (startType === 'year') {
      resStr = year + '-' + month + '-' + date
    } else if (startType === 'minutes') {
      resStr = year + '-' + month + '-' + date + ' ' + hours + ':' + minutes + ':' + second
    } else if (startType === 'time') {
      resStr = hours + ':' + minutes + ':' + second
    } else if (startType === 't') {
      resStr = hours + ':' + minutes
    } else {
      resStr = year + '-' + month + '-' + date + ' ' + hours + ':' + minutes
    }
    return resStr
  } else {
    return ''
  }
}

/**
 * @param {Array} data 传入的同层数据
 * @description 将同层数据转换成树形数据
 */
export const toTree = (data, name) => {
  // 删除 所有 children,以防止多次调用
  // data.forEach(function (item) {
  //   delete item.children;
  // });
  let children = 'children'
  if (name) {
    children = name
  }
  // 将数据存储为 以 id 为 KEY 的 map 索引数据列
  var map = {}
  data.forEach(function (item) {
    map[item.id] = item
  })
  var val = []
  data.forEach(function (item) {
    // 以当前遍历项，的parentId,去map对象中找到索引的id
    // item.label = item.areaName;
    var parent = map[item.parentId]
    // 如果找到索引，那么说明此项不在顶级当中,那么需要把此项添加到，他对应的父级中
    if (parent) {
      (parent[children] || (parent[children] = [])).push(item)
    } else {
      // 如果没有在map中找到对应的索引ID,那么直接把 当前的item添加到 val结果集中，作为顶级
      val.push(item)
    }
  })
  return val
}


//获取本月最后一天
export const getLastDate = (flag) => {
  var date = new Date()
  date.setDate(28)
  date.setMonth(date.getMonth() + 1)
  date.setDate(0)
  let lastDay = date.getDate()
  let year = date.getUTCFullYear(),
  month = date.getMonth(),
  day = date.getDate()
  if(flag==="yyyy-MM-dd"){
    return `${year}-${month+1}-${day}`
  }else{
    return lastDay
  }
}
//获取本月第一天
export const getFirstDate = () => {
  var date = new Date()
  date.setDate(1)
  let year = date.getUTCFullYear(),
  month = date.getMonth(),
  day = date.getDate()
  return `${year}-${month+1}-${day}`
}

// 获取当天晚上
export const getDateStart = () => {
  const start = new Date(new Date(new Date().toLocaleDateString()).getTime())
  let year = start.getUTCFullYear(),
  month = start.getMonth(),
  day = start.getDate()
  return `${year}-${month+1}-${day}`
}
// 获取当天凌晨
export const getDateEnd = () => {
  const start = new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1)
  let year = start.getUTCFullYear(),
  month = start.getMonth(),
  day = start.getDate()
  return `${year}-${month+1}-${day}`
}

//根据排序属性(prop)向数组(array)中插入元素(item)，排序属性默认为sort
export const insertItemByOrderProp = (array, item, prop="sort") => {
  if (Array.isArray(array) && item && Number.isFinite(item[prop])) {
    let insertIndex = array.length
    array.some((e, i) => {
      if (Number.isFinite(e[prop]) && e[prop] >= item[prop]) {
        insertIndex = i
        return true
      }
    })
    array.splice(insertIndex, 0, item)
  }
}
//删除数组(array)中某属性(prop)值与给定元素(item)属性值相一致的元素
export const removeItemByProp = (array, item, prop) => {
  if (Array.isArray(array) && item && typeof prop === 'string' && item[prop]) {
    array.some((e, i) => {
      if (e[prop] === item[prop]) {
        array.splice(i, 1)
        return true
      }
    })
  }
}

// 目标item是否包含在数组中
export const inArray = (item, array) => !!(item && Array.isArray(array) && array.includes(item))
// 当选项关联了数组，且目标item不在此数组中时，选项不可选
export const optionDisable = (item, array) => !!(Array.isArray(array) && array.length && !inArray(item, array))

// 生成1位小数位百分率字符串
export const getScoreRate = (fullScore, score) => {
  if (fullScore) {
    const fsNumber = Number(fullScore)
    if (fsNumber > 0) return (Number(score)*100/fsNumber).toFixed(1)+'%'
  }
  return ''
}

export const numToStr = (value) => {
  return typeof value === 'string' ? value : (Number.isFinite(value) ? value.toString() : '')
}
export const numToStrInArray = (array) => {
  Array.isArray(array) && array.forEach((v,i) => array[i] = numToStr(v))
}